import {
  getSafeUrl,
  updateLocalRetentionUser,
  useAppDispatch,
  useAppSelector,
  useGetRegionsQuery,
  useGetUserOrgNodesQuery,
  useUserLoginQuery,
  userPermissionCheck
} from '@monorepo/shared';
import { debugMode, EnvConst, HomeElms, host, server } from '../config/const';
import {
  findRedirectAccount,
  selectAccounts,
  selectLoginAccount
} from '@monorepo/shared/store/accountSlice';
import {
  selectOU,
  selectOUError,
  selectOUStatus
} from '@monorepo/shared/store/fcOuSlice';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
  selectDebugKey,
  selectSessionStatus,
  updatePermission
} from '@monorepo/shared/store/authSlice';
import { Loader, Message, useToaster } from 'rsuite';
import { useEffect, useState } from 'react';
import { t } from 'i18next';

export const Permission = () => {
  const { state } = useLocation();
  const debugKey = useAppSelector(selectDebugKey) || state?.debug_key;
  const redirect_path = state?.redirect_path || '/organization';
  const redirect_obj = state?.redirect_obj || {};
  const user = state?.user || '';
  const globalUser = useUserLoginQuery({
    key: debugMode ? debugKey : undefined,
    server: server
  });
  const dispatch = useAppDispatch();
  const ou = useGetUserOrgNodesQuery(
    { server: server, fcName: HomeElms?.fcName, refresh: true },
    {
      skip: !globalUser.isSuccess
    }
  );

  const getRegions = useGetRegionsQuery(
    { server: server },
    {
      skip: !globalUser.isSuccess
    }
  );
  const loginAccount = useAppSelector(selectLoginAccount);
  const ouStatus = useAppSelector(selectOUStatus);
  const ouData = useAppSelector(selectOU);
  const ouError = useAppSelector(selectOUError);
  const accounts = useAppSelector(selectAccounts);

  const sessionStatus = useAppSelector(selectSessionStatus);
  const toaster = useToaster();
  const navigate = useNavigate();
  const setPermission = (value: string) => {
    dispatch(updatePermission(value));
  };
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    if (globalUser.isError) {
      const header = t('common.apiMsg.warning.global');
      const globalErrMessage = (
        <Message showIcon type="warning" closable header={header}></Message>
      );
      toaster.push(globalErrMessage, {
        placement: 'bottomEnd',
        duration: 5000
      });
      if (sessionStatus === 'REVOKED') {
        if (user) {
          updateLocalRetentionUser(user);
          window.open(
            getSafeUrl(
              `${EnvConst.auth_host}/ssologin/?next=${host}/vm-retention`
            ),
            '_self'
          );
        } else {
          window.open(getSafeUrl(`${server}`), '_self');
        }
      }
      console.warn('------ global user login data error', globalUser.error);
      setPermission('failed');
    }
    if (ouStatus === 'failed') {
      const header = t('common.apiMsg.warning.ou', {
        status: ouError.status || ''
      });
      const ouErrMessage = (
        <Message showIcon type="warning" closable header={header}>
          {ouError.data}
        </Message>
      );
      toaster.push(ouErrMessage, {
        placement: 'bottomEnd',
        duration: 5000
      });
      setPermission('pending');
    }
  }, [globalUser, ouStatus, sessionStatus]);

  useEffect(() => {
    if (ouStatus === 'succeeded' && getRegions.isSuccess) {
      const checkAccount =
        findRedirectAccount({
          accounts,
          redirect_obj
        }) || loginAccount;
      if (userPermissionCheck(checkAccount, HomeElms?.fcName)) {
        setPermission('passed');
      } else {
        console.warn('------ user permission check failed', checkAccount);
        if (checkAccount?.user_auth_url && window) {
          window.open(getSafeUrl(`${checkAccount.user_auth_url}`), '_self');
        }
        setPermission('failed');
        navigate('/cred/no-permission');
      }
      setIsReady(true);
    }
  }, [loginAccount, getRegions, ouStatus]);

  return (
    <>
      {isReady ? (
        <Navigate to={redirect_path} replace state={state} />
      ) : (
        <Loader center content={t('common.loading')} />
      )}
    </>
  );
};
